// extracted by mini-css-extract-plugin
module.exports = {"smartforceLegend":"SmartforceLegend_smartforceLegend__3uL3m","strong":"SmartforceLegend_strong__1k1Yi"};